import UsersModel from '../Apis/Users'
import Controller from './Controller'
import { serialize } from 'object-to-formdata';

export default class UsersController extends Controller {
  constructor() {
    super(new UsersModel())
  }

  async getStatistics(){
    return await this.model.getStatistics();
  }
  async register(data) {


    const formData = serialize(data, this.options);


    let res = await this.model.register(formData, this.headers);
    return res

  }
  async Show(id){
    let params = {};
    params.with = ['quranProgramSchedulesDates','country','quranProgram','quranProgramstudent'];
    let res = await this.model.Show(id,params);
    return res;
  }
  async forgot(data) {
    let res = await this.model.forgot(data);
    return this.Poup(res);

  }
  async reset(data) {
    let res = await this.model.reset(data);
    return this.Poup(res);

  }
  async sendUserRequest(data) {


    const formData = serialize(data, this.options);


    let res = await this.model.sendUserRequest(formData, this.headers);
    return res

  }

  async eduProgramUsers(eduProgramId, data) {
    let res = await this.model.eduProgramUsers(eduProgramId, data);
    return res;
  }
  async getAllOnline(params) {
    let res = await this.model.getAllOnline(params);
    return res;
    
  }

  async getTeachers(params) {
    let res = await this.model.getTeachers(params);
    return res;
  }
  async teachers(params) {
    let res = await this.model.teachers(params);
    return res;
  }
  async saveTeachers(params) {
    let res = await this.model.saveTeachers(params);
    return res;
  }
  async ToggleActivation(user) {
    const res = await this.model.ToggleActivation(user)
    return this.Poup(res);

  }

  async getOnlineApplication(params) {
    const data = await this.model.getOnlineApplication(params)
    return data
  }

  async OnlineApplication(id) {
    const data = await this.model.OnlineApplication(id)
    return data
  }
  async getFile(id) {
    console.log(id);
    const data = await new UsersModel().getAllFile(id)
    return data
  }
  async sendFile(data) {

    const formData = serialize(data, this.options);


    let res = await this.model.sendFile(formData, this.headers);
    return res
  }
  async admissionstatus(data) {
    let res = await this.model.admissionstatus(data);
    return res
  }
  //
  async enrollmentInfo(data) {
    let res = await this.model.enrollmentInfo(data);
    return res
  }
  async letterOffer(data, headers = {}) {
    const formData = serialize(data, this.options);

    let res = await this.model.letterOffer(formData, this.headers);
    return res
  }
  async getStudentsDataStatics(){
    let res = await this.model.getStudentsDataStatics();
    return res
  }
  async GetAllTeachersFromQuranShedule(){
    let res = await this.model.GetAllTeachersFromQuranShedule();
    return res
  }

  async GetAllFilteredByTeacher(params){
    let res = await this.model.GetAllFilteredByTeacher(params);
    return res
  }

  async deleteProfile() {
    let res = await this.model.deleteProfile();
    return res;
  }


}
